/* Bottom clearance for the floating WhatsApp control.

   The control is fixed at bottom-left. Three bottom-anchored surfaces can share
   that band: the legacy full-width `bundle_sticky_atc` bar, the sham builder
   pill, and the recipe page's mobile order bar. Which builder bar renders
   depends on settings.sham_subscription_defer_enabled, not on the template, so
   the clearance is measured off whatever is actually on the page. The pill is right-aligned and
   content-width, so whether it overlaps the control's column is measured too,
   never assumed. */

(() => {
  const control = document.querySelector('.sham-whatsapp');
  if (!control) return;

  const LEGACY_BAR = '[data-bundle-sticky-atc]';
  const SHAM_BAR = '.sham-bundle-sticky-bar';
  const SHAM_PILL = '.sham-bundle-sticky-bar.is-visible .sham-bundle-sticky-bar__pill';
  const RECIPE_BAR = '.sham-recipe__bar';
  const RECIPE_BAR_UP = '.sham-recipe__bar.is-visible';

  const apply = () => {
    const column = control.getBoundingClientRect();
    let clearance = 0;

    for (const bar of document.querySelectorAll(`${LEGACY_BAR}, ${SHAM_PILL}, ${RECIPE_BAR_UP}`)) {
      const box = bar.getBoundingClientRect();
      if (box.width === 0 || box.height === 0) continue;
      if (box.right <= column.left || box.left >= column.right) continue;
      clearance = Math.max(clearance, Math.ceil(window.innerHeight - box.top));
    }

    if (clearance === 0) control.style.removeProperty('--sham-whatsapp-clearance');
    else control.style.setProperty('--sham-whatsapp-clearance', `${clearance}px`);
  };

  const observe = () => {
    const bars = [document.querySelector(LEGACY_BAR), document.querySelector(SHAM_BAR), document.querySelector(RECIPE_BAR)].filter(Boolean);
    if (bars.length === 0) return;

    const resizes = new ResizeObserver(apply);
    // The legacy bar is parked below the fold and slides up on load with no
    // size change and no class change of its own, so size and class are both
    // blind to it. Crossing the viewport edge is the signal that catches it.
    const entries = new IntersectionObserver(apply, { threshold: [0, 0.01, 0.5, 1] });

    for (const bar of bars) {
      resizes.observe(bar);
      entries.observe(bar);
      // Belt for a move that stays inside the viewport, which trips no
      // threshold: both bars arrive on a transform transition.
      bar.addEventListener('transitionend', apply);
      // The pill's .is-visible decides whether it has a box at all.
      new MutationObserver(apply).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
  };

  const start = () => {
    apply();
    observe();
  };

  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', apply);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
